import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {NgbModule} from "@ng-bootstrap/ng-bootstrap";
import {GlobalModule} from "../global/global.module";
import {KeteranganKesehatanComponent} from "./keterangan-kesehatan.component";
import {KeteranganKesehatanRoutingModule} from "./keterangan-kesehatan-routing.module";



@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    KeteranganKesehatanRoutingModule,
    GlobalModule
  ],
  declarations: [
    KeteranganKesehatanComponent
  ]
})
export class KeteranganKesehatanModule { }
